import { fieldAddApi } from "../../api/field/fieldAddApi"

type PayloadShape = Parameters<typeof fieldAddApi>[0]

export async function fieldAddService(payload: PayloadShape, token: string) {
	return await fieldAddApi(payload, token)
}
